import { fetchGet } from '../helperApi'

export const fetchAssessmentPackagesApi = () => {
    return fetchGet(`packages`)
}
